<template>
  <div class="animated fadeIn">

    <b-card>
      <h2>Help &amp; Support</h2>
      <div class="lead">Get answers to frequently asked questions and contact us for more assistance</div>
    </b-card>

    <b-card>
      <h2 class="mb-4">FAQ</h2>

      <ul class="counted">
        <li>
          <h4>How much does it cost?</h4>
          <p>To keep things simple, we offer a single price plan that includes everything you need. Please visit your account page to subscribe to a plan. Our plans are subject to change at any time, however if you sign up for a plan, you can keep it forever! You can cancel at any time, so try us out for a month and see how much time we can save you!</p>
        </li>
        <li>
          <h4>How do I pay? Is it secure?</h4>
          <p>Our payment processing is handled offsite by Stripe, a world-leading payment processor that represents large brands like Twitter, Kickstarter and Shopify. We do not store any of your payment information &mdash; all of that is handled by Stripe &mdash; we are simply notified of a successful or failed payment.</p>
          <p>Feel free to <a href="https://stripe.com/" target="_blank" rel="noreferrer nofollow">visit Stripe</a> to find out more about their security standards and look out for the “Powered by Stripe” logo on our billing page.</p>
        </li>
        <li>
          <h4>I need more listings and customized posting schedules</h4>
          <p>If you have customized needs, please send us an email using the form below. If what you need is simple enough to manually adjust on your account, we’ll do it. If it’s more complex or requires customized pricing, we’re more than happy to help and discuss the details!</p>
        </li>
      </ul>
    </b-card>

    <b-row>
      <b-col :md="8" :offset-md="2">
        <b-card v-loading="loading" :element-loading-text="loadingText">
          <b-form-group>
            <h2>Get in Touch</h2>
            <div class="lead mb-4">Still need help? Send us an email, we're happy to chat with you!</div>
            <b-form-textarea v-model="message" :rows="6" placeholder="Your Message" />
          </b-form-group>
          <div class="text-center">
            <vue-recaptcha ref="captcha" sitekey="6LcHznUUAAAAAO3Z2Qzc8WWXQRu7TQt6-2yp951U" @verify="contact" badge="inline" style="margin: 0 auto;" class="d-inline-block">
              <b-button size="lg" variant="primary" class="mt-4" @click="challenge()">Contact Us</b-button>
            </vue-recaptcha>
          </div>

          <b-alert :show="!!success" fade variant="success" class="mt-4 mb-0">{{success}}</b-alert>
          <b-alert :show="!!error" fade variant="danger" class="mt-4 mb-0">{{error}}</b-alert>
        </b-card>
      </b-col>
    </b-row>

  </div>
</template>

<script>
const ContactingText = 'Sending...'

import VueRecaptcha from 'vue-recaptcha'

export default {
  name: 'Support',

  components: {
    VueRecaptcha
  },

  data(){
    return {
      message: '',

      // State
      loading     : false,
      loadingText : ContactingText,
      success     : '',
      error       : ''
    }
  },

  methods: {
    reset(){
      this.loading = false
      this.message = ''
      this.success = ''
      this.error = ''
    },

    challenge(){
      this.loading = true
      this.loadingText = ContactingText
    },

    contact(response){
      this.$API.v2.Support.ContactUs(this.message, response)
      .then(() => {
        this.reset()
        this.success = 'Your message was sent successfully!'
      })
      .catch((err) => {
        this.error = err
      })
      .finally(() => {
        this.loading = false
        this.$refs.captcha.reset()
      })
    }
  }
};
</script>

<style lang="scss" scoped>
.counted {
  counter-reset: faq;
  list-style-type: none;
  margin: 0;
  padding: 0;

  li {
    position: relative;
    margin-left: 20px;
    padding-left: 70px;
    margin-bottom: 40px;

    &::before {
      counter-increment: faq;
      content: counters(faq, ".");
      position: absolute;
      top: 0;
      left: 0;
      width: 50px;
      height: 50px;
      border-radius: 25px;
      text-align: center;
      line-height: 45px;
      border: 2px solid #3483d5;
      color: #3483d5;
      font-size: 24px;
      font-weight: 600;
    }
  }
}
</style>
